import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, KeyRound } from "lucide-react";
import { api } from "@/lib/api";
import { RECUPERAR } from "@/constants/testIds";
import { usePageTitle } from "@/lib/usePageTitle";

export default function RecuperarContrasena() {
  usePageTitle("Recuperar contraseña");
  const [email, setEmail] = useState("");
  const [enviado, setEnviado] = useState(false);
  const [cargando, setCargando] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      // El backend siempre responde igual; un error acá es de red y mostramos el mismo
      // mensaje genérico (no confirmamos ni negamos si el email existe).
    } finally {
      setCargando(false);
      setEnviado(true);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--tc-surface)] px-5">
      <div className="w-full max-w-sm rounded-[var(--tc-radius)] border border-[var(--tc-border)] bg-white p-8 tc-fade-up">
        <div className="mb-6 flex flex-col items-center text-center">
          <span className="flex h-11 w-11 items-center justify-center rounded-[var(--tc-radius)] bg-[var(--tc-accent)] text-white">
            <KeyRound size={20} strokeWidth={2.2} />
          </span>
          <h1 className="mt-3 text-lg font-semibold text-[var(--tc-text)]">Recuperar contraseña</h1>
          <p className="mt-1 text-sm text-[var(--tc-text-secondary)]">Te mandamos un enlace para restablecerla</p>
        </div>

        {enviado ? (
          <p data-testid={RECUPERAR.success} className="rounded-[var(--tc-radius)] bg-green-50 px-3 py-3 text-sm text-green-700">
            Si el email está registrado, vas a recibir un enlace para restablecer tu contraseña. Es válido por 30 minutos.
          </p>
        ) : (
          <form onSubmit={onSubmit} className="flex flex-col gap-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-[var(--tc-text)]">Email</label>
              <input
                data-testid={RECUPERAR.emailInput}
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-[var(--tc-radius)] border border-[var(--tc-border)] px-3.5 py-2.5 text-sm outline-none focus:border-[var(--tc-accent)] focus:ring-2 focus:ring-[var(--tc-accent-soft)]"
                placeholder="tu@email.com"
              />
            </div>
            <button
              data-testid={RECUPERAR.submitButton}
              type="submit"
              disabled={cargando}
              className="mt-1 inline-flex items-center justify-center gap-2 rounded-[var(--tc-radius)] bg-[var(--tc-accent)] px-4 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[var(--tc-accent-hover)] disabled:cursor-not-allowed disabled:opacity-60"
            >
              {cargando ? <Loader2 size={16} className="animate-spin" /> : null} Enviar enlace
            </button>
          </form>
        )}

        <div className="mt-6 flex justify-center gap-4 text-sm">
          <Link data-testid={RECUPERAR.backToAdminLink} to="/admin/login" className="text-[var(--tc-accent)] hover:underline">
            Panel interno
          </Link>
          <Link data-testid={RECUPERAR.backToPortalLink} to="/portal/login" className="text-[var(--tc-accent)] hover:underline">
            Portal cliente
          </Link>
        </div>
      </div>
    </div>
  );
}
